import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Close } from "@mui/icons-material";
import { IconButton, MenuItem, TextField, Typography } from "@mui/material";

import { emailRegex } from "constants/appConstants";

import { inviteNewUser, updateUserAppRoleAction } from "actions/userActions";
import { fetchApplicationRolesAction } from "actions/appActions";
import { getApplicationRoles } from "selectors/appSelector";

export const ChangeUserRole = ({ onCancel, selectedUser, setEditUser }) => {
  const dispatch = useDispatch();
  const applicationRoles = useSelector(getApplicationRoles);
  const [selectedRole, setSelectedRole] = useState("");

  console.log("CHeck the APplication Roes", applicationRoles);

  const fetchAppRoles = useCallback(() => {
    dispatch(fetchApplicationRolesAction());
  }, [dispatch]);

  useEffect(() => {
    fetchAppRoles();
  }, [fetchAppRoles]);

  const getRoleLabel = (role) => {
    if (!role) return "Select Role";
    return `${role.applUserCategory} ${role.applUserType}`;
  };

  return (
    <div>
      <div>
        <div className="d-flex justify-content-between align-items-center">
          <Typography className="h4">Change User Role</Typography>
          <Close onClick={onCancel} className="pointer" />
        </div>
        <Typography className="body1 mt-2" style={{ color: "#666" }}>
          You are about to modify the organizational role for{" "}
          <strong>
            {selectedUser?.firstName} {selectedUser?.lastName}
          </strong>{" "}
          ({selectedUser?.email}). This action will change their access level
          and responsibilities within your organization's Builder application.
        </Typography>

        <div
          className="mt-3 p-3"
          style={{ backgroundColor: "#f5f5f5", borderRadius: "8px" }}
        >
          <Typography
            className="body2"
            style={{ color: "#333", fontWeight: "600" }}
          >
            Role Definitions & Permissions:
          </Typography>
          <Typography className="body2 mt-2" style={{ color: "#666" }}>
            <strong>• General Manager:</strong>
            <br />
            &nbsp;&nbsp;- Full administrative access to all organizational
            features
            <br />
            &nbsp;&nbsp;- Manage users, projects, and system configurations
            <br />
            &nbsp;&nbsp;- Access to financial data, reports, and analytics
            <br />
            &nbsp;&nbsp;- Assign roles and manage team permissions
          </Typography>
          <Typography className="body2 mt-2" style={{ color: "#666" }}>
            <strong>• Team Member:</strong>
            <br />
            &nbsp;&nbsp;- Limited access focused on daily operational tasks
            <br />
            &nbsp;&nbsp;- Can view and update assigned projects and tasks
            <br />
            &nbsp;&nbsp;- Access to relevant documentation and communication
            tools
            <br />
            &nbsp;&nbsp;- Cannot modify system settings or manage other users
          </Typography>
        </div>

        <Typography className="body2 mt-3" style={{ color: "#ff9800" }}>
          ⚠️ <strong>Important:</strong> Ensure the user is aware of their new
          role responsibilities and has received appropriate training if needed.
        </Typography>

        <Typography className="body2 mt-2" style={{ color: "#1976d2" }}>
          📋 <strong>Post-Change Actions Required:</strong>
          <br />
          • User must log out and log back in to see the changes
          <br />
          • Notify the user about their updated permissions
          <br />• Update any relevant documentation or team communications
        </Typography>
      </div>
      <div className="d-flex gap-2 mt-4 align-items-center">
        <Typography className="h5" style={{ minWidth: "120px" }}>
          Current Role:
        </Typography>
        <Typography
          className="body1"
          style={{ color: "#1976d2", fontWeight: "600", marginTop: "-0.5rem" }}
        >
          {selectedUser?.role?.applUserType || "Not Set"}
        </Typography>
      </div>
      <div className="d-flex gap-2 mt-3 align-items-center">
        <Typography className="h5" style={{ minWidth: "120px" }}>
          New Role: <span style={{ color: "red" }}>*</span>
        </Typography>
        <TextField
          className="form-field"
          placeholder="Select New Role"
          select
          value={selectedRole?.applRoleName}
          onChange={(_, { props }) => {
            setSelectedRole(props?.option);
          }}
          displayEmpty
          style={{ minWidth: "200px" }}
          SelectProps={{
            displayEmpty: true,
            renderValue: () => {
              return (
                <Typography>
                  {getRoleLabel(selectedRole) || "Select New Role"}
                </Typography>
              );
            },
          }}
        >
          <MenuItem value="" disabled>
            Select Application Role
          </MenuItem>
          {applicationRoles
            .filter(
              (role) => role?.applUserType !== selectedUser?.role?.applUserType
            )
            .map((role) => (
              <MenuItem
                key={role.applRoleName}
                value={role.applRoleName}
                option={role}
              >
                {getRoleLabel(role)}
              </MenuItem>
            ))}
        </TextField>
      </div>

      {selectedRole?.applUserType &&
        selectedRole?.applUserType !== selectedUser?.role?.applUserType && (
          <div
            className="mt-3 p-2"
            style={{
              backgroundColor: "#e3f2fd",
              borderRadius: "4px",
              border: "1px solid #1976d2",
            }}
          >
            <Typography className="body2" style={{ color: "#1565c0" }}>
              <strong>Confirmation:</strong> You are changing{" "}
              {selectedUser?.firstName}'s role from{" "}
              <strong>{selectedUser?.role?.applUserType}</strong> to{" "}
              <strong>{getRoleLabel(selectedRole)}</strong>
            </Typography>
          </div>
        )}

      <div className="d-flex mt-4 justify-content-end gap-3">
        <button
          className="secondaryButton"
          onClick={() => {
            onCancel();
          }}
        >
          Cancel
        </button>
        <button
          className={`primaryButton ${
            !selectedRole?.applUserType ||
            selectedRole?.applUserType === selectedUser?.role?.applUserType
              ? "disabled"
              : ""
          }`}
          disabled={
            !selectedRole?.applUserType ||
            selectedRole?.applUserType === selectedUser?.role?.applUserType
          }
          onClick={() => {
            // Handle role change logic here
            dispatch(
              updateUserAppRoleAction(selectedUser, selectedRole, (payload) => {
                onCancel(true);
              })
            );
          }}
        >
          Confirm Role Change
        </button>
      </div>
    </div>
  );
};

export const AddNewUser = ({ setNewUserModel, onInviteSuccess }) => {
  const dispatch = useDispatch();
  const [emailId, setEmailId] = useState("");

  return (
    <>
      <div>
        <div className="d-flex justify-content-between">
          <Typography className="body1 mb-3">
            <strong>
              Invite User by sending an email link to create account{" "}
            </strong>
          </Typography>
          <IconButton
            onClick={() => {
              setNewUserModel(false);
            }}
            style={{ fontSize: "12px" }}
          >
            <Close style={{ fontSize: "1.5rem", marginTop: "-4px" }} />
          </IconButton>
        </div>

        <div className="">
          <label>
            <strong>User Email</strong>
          </label>
          <TextField
            placeholder="Enter Email"
            className={`form-field mt-2`}
            type="email"
            style={{ width: "90%" }}
            onChange={(event) => {
              setEmailId(event.target.value);
            }}
          />
        </div>
        <div>
          <button
            className={`primaryButton mt-3 ${
              emailId && !emailRegex.test(emailId) ? "disabled" : ""
            }`}
            style={{ width: "90%" }}
            disabled={emailId && !emailRegex.test(emailId)}
            onClick={() => {
              dispatch(
                inviteNewUser(emailId, (payload) => {
                  setNewUserModel(false);
                  onInviteSuccess(payload);
                })
              );
            }}
          >
            Send Invite
          </button>
        </div>
        {emailId && !emailRegex.test(emailId) && (
          <div>
            <Typography
              variant="body1"
              className="mt-2"
              style={{ color: "red", fontSize: "12px" }}
            >
              Enter Valid Email to send an invite
            </Typography>
          </div>
        )}
      </div>
    </>
  );
};

export const DeleteUserConfirmation = ({
  onConfirmDelete,
  onCancel,
  deleteUserSelection,
}) => {
  return (
    <div>
      <div className="mb-3">
        <Typography className="h3 mb-2" style={{ fontWeight: 600 }}>
          Delete User
        </Typography>
        <Typography className="mb-2">
          Are you sure you want to permanently delete{" "}
          <strong>
            {deleteUserSelection?.firstName} {deleteUserSelection?.lastName}
          </strong>{" "}
          from the system?
        </Typography>
        <Typography
          variant="body2"
          style={{ color: "#d32f2f", fontStyle: "italic" }}
          className="mb-1"
        >
          ⚠️ This action cannot be undone.
        </Typography>
        <Typography variant="body2" style={{ color: "#666" }}>
          • User will lose access to all projects and data
          <br />
          • User's activity history will be preserved
          <br />• Any assigned tasks will need to be reassigned
        </Typography>
      </div>
      <div className="d-flex justify-content-end gap-2 mt-3">
        <button className="secondaryButton" onClick={onCancel}>
          Cancel
        </button>
        <button
          className="primaryButton"
          style={{ backgroundColor: "#d32f2f" }}
          onClick={onConfirmDelete}
        >
          Delete User
        </button>
      </div>
    </div>
  );
};
